/**
 * PlaygroundThemeContext.tsx
 * Context and hook for playground theme management
 */

import { createContext, useContext } from 'react';
import type { PlaygroundThemeState } from './usePlaygroundTheme';

// Create theme context
export const PlaygroundThemeContext = createContext<PlaygroundThemeState | null>(null);

// Hook to use playground theme context
export const usePlaygroundThemeContext = (): PlaygroundThemeState => {
  const context = useContext(PlaygroundThemeContext);
  if (!context) {
    throw new Error('usePlaygroundThemeContext must be used within PlaygroundApp');
  }
  return context;
};